import {ESettingsFrontType} from '@/config/enums';

import type {
  ISettings,
  ISettingsKeycloak,
  ISettingsServicesBack,
} from './types';
import {validateUrl} from '@/assets/core/assets/helpers/validate';

const logError = (message: string) => {
  console.error(message);
};

export const getFrontType = () => {
  const meta = document.querySelector(
    'meta[name="front-type"]',
  ) as HTMLMetaElement;
  return (meta?.content as ESettingsFrontType) ?? ESettingsFrontType.CLIENT;
};

export const validateServiceUrl = (url: string, service: string) => {
  validateUrl(url).then((valid) => {
    if (valid) return;
    else if (url.includes('__PLACEHOLDER'))
      logError(`${service} url не указан`);
    else logError(`${service} url не валидный`);
  });
};

export const validateSettings = (settings: ISettings) => {
  Object.entries(settings.SERVICES).forEach(([key, value]) => {
    let settings;
    if (key === 'KEYCLOAK') {
      settings = value as ISettingsKeycloak;
      if (settings.REALM.includes('__PLACEHOLDER'))
        logError(`KEYCLOAK realm не указан`);
      if (settings.CLIENT_ID.includes('__PLACEHOLDER'))
        logError(`KEYCLOAK client id не указан`);
      if (settings.CLIENT_ID_ROLES.includes('__PLACEHOLDER'))
        logError(`KEYCLOAK client id roles не указан`);
    }

    if (key === 'FRONT') return;

    settings = value as ISettingsServicesBack;
    validateServiceUrl(settings.URL, key);
  });
};
